/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useHistory } from 'react-router';
import CustomSeparator from '../../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import SVGComponent from '../../../../../SharedModules/SVGComponents/SVGComponents';

function OnlineFixes() {
  const history = useHistory();

  const [moduleName, setModuleName] = useState('UNI');
  const [moduleLabel, setModuleLabel] = useState('');

  const handleSelection = (e) => {
    setModuleName(e.target.value);
  };

  const processNavigation = () => {
    let screenName = '';
    switch (moduleName) {
      case 'UNI':
        screenName = 'unfreezeInvoice';
        break;
      case 'RCLSD':
        screenName = 'removeSuspendedDt';
        break;
      case 'DCL':
        screenName = 'deleteCheckLog';
        break;
      case 'DB':
        screenName = 'requestdeletebatch';
        break;
      case 'CSI':
        screenName = 'createStubInvoice';
        break;
      case 'CNCECMS':
        screenName = 'reqInitCorrectCmsReport';
        break;
      case 'APCOCT':
        screenName = 'requestedPreviousClaim';
        break;
      case 'RECMS':
        screenName = 'researchexisitngcms64report';
        break;
      case 'UPG':
        screenName = 'updateGeneralParam';
        break;
      case 'ADLLE':
        screenName = 'addordeleteloadlogemail';
        break;
      default:
        screenName = 'Wip';
        break;
    }
    // history.push({ pathname: `/${screenName}` });
    navigateToPage(
      `/${screenName}`,
      screenName === 'Wip' ? 'Work In Progress' : moduleLabel
    );
  };

  const navigateToPage = (pathName, value) => {
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) == null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    if (updateTabs.findIndex((item) => item.navTo === pathName) === -1) {
      updateTabs.push({
        navTo: pathName,
        value: value,
      });
      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    }

    history.push({
      pathname: pathName,
    });
  };

  // Added displaylabel as extra key value pair in Array to make constant header value in tabs.
  const onlineFixRadio = [
    {
      label: 'Create New or Correct Existing CMS 64 Report',
      value: 'CNCECMS',
      displaylabel: 'Search Req Init Correct CMS 64 Rpt',
    },
    {
      label: 'Research Existing CMS 64 Report',
      value: 'RECMS',
      displaylabel: 'Search Req Init Correct CMS64 Rpt',
    },
    { label: 'Update DQD', value: 'UDQD', displaylabel: 'Work In Progress' },
    {
      label: 'Unfreeze Invoice',
      value: 'UNI',
      displaylabel: 'Unfreeze Invoice',
    },
    {
      label: 'Remove Check Log Suspended Date',
      value: 'RCLSD',
      displaylabel: 'Remove Suspended Date',
    },
    {
      label: 'Create Stub Invoice',
      value: 'CSI',
      displaylabel: 'Request Stub Invoice Creation',
    },
    {
      label: 'Add Previous Claim to Omitted Claim Table',
      value: 'APCOCT',
      displaylabel: 'Add Previous Claim to Omitted Claim Table',
    },
    {
      label: 'Delete Check Log',
      value: 'DCL',
      displaylabel: 'Request Delete Check Log',
    },
    {
      label: 'Delete Batch',
      value: 'DB',
      displaylabel: 'Request Delete Batch',
    },
    {
      label: 'Add or Delete Load Log Email',
      value: 'ADLLE',
      displaylabel: 'Maintain Load Log Email',
    },
    {
      label: 'Update Param General',
      value: 'UPG',
      displaylabel: 'Update Param General',
    },
  ];

  // Modulelabel value change from label to displaylabel
  useEffect(() => {
    if (moduleName) {
      const filterArr = onlineFixRadio.filter(
        (item) => item.value === moduleName
      );
      if (filterArr.length > 0) {
        setModuleLabel(filterArr[0].displaylabel);
      }
    }
  }, [moduleName]);

  return (
    <div className="tabs-container">
      <div className="tBillPanel custom-check">
        <div className="panel tBillPanel-space pb-0">
          <CustomSeparator
            parent1="System"
            parent2="Technical Window"
            parent3="Online Fixes"
          />
          <div className="row">
            <div className="col-sm-12">
              <fieldset className="custom-fieldset">
                <legend className="same-font-family">Function</legend>
                <div className="form-wrapper p-0 mt-2">
                  <div className="mui-custom-form input-md field-xl">
                    <div
                      className="sub-radio no-margin"
                      id="demo-row-radio-buttons-group-label"
                    >
                      <FormControl>
                        <RadioGroup
                          row
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          name="function"
                          onChange={handleSelection}
                          value={moduleName || ''}
                          required
                        >
                          {onlineFixRadio.map((item, index) => (
                            <div className="col-sm-12">
                              <FormControlLabel
                                style={{ marginRight: '30px' }}
                                value={item.value}
                                control={<Radio />}
                                label={item.label}
                                data-test={item.value}
                                key={`${item.value}-${index}`}
                              />
                            </div>
                          ))}
                        </RadioGroup>
                      </FormControl>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
          <div className="row float-right">
            <div className="btn-wrapper mb-2">
              <div className="mt-1 ml-4 hide-on-print">
                <Button
                  className="btn-success same-font-family frr-btn-width-17 mt-4"
                  onClick={processNavigation}
                >
                  <SVGComponent iconName="Create-new-icon" /> Process
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OnlineFixes;
